export default {
    common: {
        title: "Bild bearbeiten",
        cancel: "Abbrechen",
        save: "sichern",
        crop: "Ernte",
        adjustments: "Anpassungen",
        filters: "Filter",
        frames: "Rahmen",
        overlays: "Überlagerungen",
        text: "Text",
        stickers: "Aufkleber",
        brush: "Bürste",
        ai: "Bild mit KI erstellen",
        reset: "Reset",
        comingSoon: 'Bald erhältlich...',
    },
};
